/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";
import { ScheduleFiltersStore } from "../store/store";

/**
 * Resets the schedule filters store.
 */
export const resetScheduleFilters = mutatorAction(
    "resetScheduleFilters",
    () => {
        ScheduleFiltersStore().scheduleFilters = undefined;
    }
);